import React, { Component, Fragment } from "react";
import "./SearchOptionScreen.scss";

export class SearchOptionScreen extends Component {
  constructor(props){
    super(props);
    props.fetchFilters();
  }

  render(){
    if(!this.props.isInitialized)
      return "Loading...";

    const make = this.props.filters.find(f => f.key === 'make');
    const type = this.props.filters.find(f => f.key === 'type');

    return (
      <div className="grid" style={{marginTop: '50px'}}>
        {[make, type].map(filter => {
             return (
               <Fragment>
                  <div className="col-1"></div>
                  <div className="col-9">
                    <div className="search-option">
                      <span>{filter.label}</span>
                      <div className="search-option__panel">
                        <ul style={{columnCount: 4}}>
                          {filter.options.map(option => (
                            <li style={{padding: '0 10px'}}>
                              <a href={`/?searchBy=${filter.key}&${filter.key}=${option.value}`}>{option.label}</a>
                            </li>))
                          }            
                        </ul>
                      </div>
                    </div>
                    
                  </div>
                  <div className="col-2"></div>
              </Fragment>
             )
        })
      }

      </div>
    );
  }
}